<template>
  <div style="padding: 10px;">
    <div style="margin-bottom: 20px;display: flex;flex-direction: row;">
      <div style="height: 20px;width: 3px;background:#55acee;"></div>
      <span style="line-height: 20px;margin-left: 5px;font-size: 16px;font-weight: 300;">文章统计</span>
    </div>
    <!-- 文章统计指标 -->
    <a-row>
      <a-col :span="24">
        <a-card>
          <a-row>
            <a-col :span="8">
              <a-statistic title="总阅读量" :value="articleStatistic.viewCount">
                <template #suffix>
                  <UserOutlined />
                </template>
              </a-statistic>
            </a-col>
            <a-col :span="8">
              <a-statistic title="总点赞量" :value="articleStatistic.voteCount">
                <template #suffix>
                  <like-outlined />
                </template>
              </a-statistic>
            </a-col>
            <a-col :span="8">
              <a-statistic title="点赞率" :value="articleStatistic.voteCount / articleStatistic.viewCount * 100" :precision="2"
                suffix="%" :value-style="{ color: '#cf1322' }">
                <template #suffix>
                  <like-outlined />
                </template>
              </a-statistic>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
    <br>
    <a-row :gutter="16">
      <a-col :span="12">
        <a-card>
          <a-row>
            <a-col :span="12">
              <a-statistic title="今日阅读" :value="articleStatistic.todayViewCount" style="margin-right: 50px">
                <template #suffix>
                  <UserOutlined />
                </template>
              </a-statistic>
            </a-col>
            <a-col :span="12">
              <a-statistic title="今日点赞" :value="articleStatistic.todayVoteCount">
                <template #suffix>
                  <like-outlined />
                </template>
              </a-statistic>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card>
          <a-row>
            <a-col :span="12">
              <a-statistic title="预计今日阅读" :value="articleStatistic.todayViewIncrease" :value-style="{ color: '#0000ff' }">
                <template #suffix>
                  <UserOutlined />
                </template>
              </a-statistic>
            </a-col>
            <a-col :span="12">
              <a-statistic title="预计今日阅读增长" :value="articleStatistic.todayViewIncreaseRateAbs" :precision="2" suffix="%"
                class="demo-class"
                :value-style="articleStatistic.todayViewIncreaseRate < 0 ? { color: '#3f8600' } : { color: '#cf1322' }">
                <template #prefix>
                  <arrow-down-outlined v-if="articleStatistic.todayViewIncreaseRate < 0" />
                  <arrow-up-outlined v-if="articleStatistic.todayViewIncreaseRate >= 0" />
                </template>
              </a-statistic>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
    <br>
    <!-- 文章近 30 天统计指标 -->
    <a-row>
      <a-card :style="{ width: '100%' }">
        <a-col :span="24" id="main-col">
          <div id="main" style="width: 100%;height:300px;"></div>
        </a-col>
      </a-card>
    </a-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import axios from 'axios';
import { message } from 'ant-design-vue';

declare let echarts: any;

export default defineComponent({
  name: 'TheStatisticArticle',
  setup() {

    // 文章统计数据
    const articleStatistic = ref();
    articleStatistic.value = {};

    // ------------------ 文章 ------------------

    /**
     * 文章统计指标 
     */
    const getArticleStatistic = () => {

      axios.get('/report/article/statistics').then((response) => {
        const result = response.data;
        console.log('result statistic => ', result)
        if (result.code == 0 && result.message == 'success') {
          const data = result.data;
          articleStatistic.value.viewCount = data[0].viewCount;
          articleStatistic.value.voteCount = data[0].voteCount;
          articleStatistic.value.todayViewCount = data[0].viewIncrease;
          articleStatistic.value.todayVoteCount = data[0].voteIncrease;

          // 按分钟计算当前时间点，占一天的百分比
          const now = new Date();
          const nowRate = (now.getHours() * 60 + now.getMinutes()) / (60 * 24);
          // console.log(nowRate)
          articleStatistic.value.todayViewIncrease = parseInt(String(data[0].viewIncrease / nowRate));
          // todayViewIncreaseRate：今日预计增长率
          articleStatistic.value.todayViewIncreaseRate = (articleStatistic.value.todayViewIncrease - data[0].viewIncrease) / data[0].viewIncrease * 100;
          articleStatistic.value.todayViewIncreaseRateAbs = Math.abs(articleStatistic.value.todayViewIncreaseRate);
        } else {
          message.error(result.message)
        }
      });
    };

    /**
     * 文章近 30 天统计数据
     */
    const getArticle30DayStatistic = () => {

      axios.get('/report/article/30-statistics').then((response) => {
        const result = response.data;
        console.log('result 30 statistic => ', result)
        if (result.code == 0 && result.message == 'success') {
          const data = result.data;
          console.log('statistic data => ', data)

          initArticle30DayEcharts(data)
        } else {
          message.error(result.message)
        }
      });
    };

    /**
     * 初始化文章 近 30天数据
     * @param list
     */
    const initArticle30DayEcharts = (list: any) => {
      // 发布生产后出现问题：切到别的页面，再切回首页，报表显示不出来
      // 解决方法：把原来的id=main的区域清空，重新初始化
      const mainDom = document.getElementById('main-col');
      if (mainDom) {
        mainDom.innerHTML = '<div id="main" style="width: 100%;height:300px;"></div>';
      }
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.getElementById('main'));

      const xAxis = [];
      const seriesView = [];
      const seriesVote = [];
      for (let i = 0; i < list.length; i++) {
        const record = list[i];
        xAxis.push(record.date);
        seriesView.push(record.viewIncrease);
        seriesVote.push(record.voteIncrease);
      }

      // 指定图表的配置项和数据
      const option = {
        title: {
          text: '30天趋势图'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['总阅读量', '总点赞量']
        },
        grid: {
          left: '1%',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxis
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '总阅读量',
            type: 'line',
            // stack: '总量', 不堆叠
            data: seriesView,
            smooth: true
          },
          {
            name: '总点赞量',
            type: 'line',
            // stack: '总量', 不堆叠
            data: seriesVote,
            smooth: true
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    };

    onMounted(() => {

      getArticleStatistic();

      getArticle30DayStatistic();

    });

    return {
      articleStatistic
    }
  }
});
</script>
<style scoped></style>
